/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrop32 = createReactComponent("outline", "crop-3-2", "IconCrop32", [["path", { "d": "M4 7m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

export { IconCrop32 as default };
//# sourceMappingURL=IconCrop32.mjs.map
